/* eslint no-use-before-define: 0 */

export function byTag(parent, tag) {
	if(!tag) {
		tag = parent
		parent = window.document
	}
	return parent.getElementsByTagName(tag)
}

export function byId(id) {
	return window.document.getElementById(id)
}

export function byClass(parent, className) {
	if(!className) {
		className = parent
		parent = window.document
	}
	return parent.getElementsByClassName(className)
}

export function first(parent, selector) {
	if(!selector) {
		selector = parent
		parent = window.document
	}
	return parent.querySelector(selector)
}

export function all(parent, selector) {
	if(!selector) {
		selector = parent
		parent = window.document
	}
	return parent.querySelectorAll(selector)
}

function getClassesNormal(elem) {
	return toArray(elem.classList)
}

function addClassNormal(elem, className) {
	elem.classList.add(className)
}

function removeClassNormal(elem, className) {
	elem.classList.remove(className)
}

function toggleClassNormal(elem, className) {
	return elem.classList.toggle(className)
}

function hasClassNormal(elem, className) {
	return elem.classList.contains(className)
}

function getClassesFallback(elem) {
	return elem.className.split(/\s+/)
}

function addClassFallback(elem, className) {
	var classes = getClasses(elem)
	if(-1 === classes.indexOf(className)) {
		elem.className = classes.concat([className]).join(' ')
	}
}

function removeClassFallback(elem, className) {
	elem.className = getClasses(elem)
		.filter(c => c !== className)
		.join(' ')
}

function toggleClassFallback(elem, className) {
	var classNames = getClasses(elem)
	var index = classNames.indexOf(className)
	if(-1 !== index) {
		classNames.splice(index, 1)
	} else {
		classNames.push(className)
	}
	elem.className = classNames.join(' ')
	return -1 === index
}

function hasClassFallback(elem, className) {
	return -1 !== getClasses(elem).indexOf(className)
}

export function toArray(v) {
	if(Array.isArray(v)) {
		return v
	}
	return Array.prototype.slice.call(v)
}

export function on(parent, type, cb) {
	if(!cb) {
		cb = type
		type = parent
		parent = window
	}
	parent.addEventListener(type, cb, false)
}

export function off(parent, type, cb) {
	if(!cb) {
		cb = type
		type = parent
		parent = window
	}
	parent.removeEventListener(type, cb, false)
}

export function forEach(elems, func) {
	var len = elems.length
	for(var i = 0; i < len; ++i) {
		func(elems[i], i)
	}
}

if(!window.document.addEventListener || !window.document.removeEventListener) {
	throw new Error('Unable to find add/remove listener functions')
}

var testElement = window.document.createElement('_')

export var getClasses = testElement.classList
	? getClassesNormal
	: getClassesFallback

export var addClass = testElement.classList && testElement.classList.add
	? addClassNormal
	: addClassFallback

export var removeClass = testElement.classList && testElement.classList.remove
	? removeClassNormal
	: removeClassFallback

export var toggleClass = testElement.classList && testElement.classList.toggle
	? toggleClassNormal
	: toggleClassFallback

export var hasClass = testElement.classList && testElement.classList.contains
	? hasClassNormal
	: hasClassFallback
